import { render } from "./ToWhomSelfScreen.vue?vue&type=template&id=9737bb3c"
import script from "./ToWhomSelfScreen.vue?vue&type=script&lang=js"
export * from "./ToWhomSelfScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__